import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService, AuthService } from '@fgb/core';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-activate-account-page',
  templateUrl: './activate-account-page.component.html',
  styleUrl: './activate-account-page.component.scss',
})
export class ActivateAccountPageComponent implements OnInit {
  isEdit: boolean = false;
  isError: boolean = false;
  isFormError: boolean = false;
  isLoaded: boolean = false;
  isSubmitted: boolean = false;
  emailAddress: string = '';
  private accountService = inject(AccountService);
  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    this.accountService.checkEmail().subscribe({
      next: (response) => {
        this.emailAddress = response.EmailAddress || '';
        if (this.emailAddress === '') {
          this.isEdit = true;
        }
      },
      error: (error) => {
        this.isError = true;
        this.isLoaded = true;
      },
      complete: () => {
        this.isLoaded = true;
      },
    });
  }

  resendEmail(): void {
    this.submit({ valid: true, email: this.emailAddress });
  }

  submit(event: { valid: boolean; email: string }): void {
    this.clearErrorMessages();

    if (event.valid) {
      const { email } = event;
      this.accountService.verifyEmail(email).subscribe({
        next: (response) => {
          if (this.isEdit) {
            this.isEdit = false;
            this.emailAddress = email;
          }
          this.isSubmitted = true;
        },
        error: (error) => {
          this.isFormError = true;
        },
      });
    }
  }

  cancel(): void {
    // if no email address, log out and redirect to login page
    if (!this.emailAddress) {
      lastValueFrom(this.authService.logout()).then(() => {
        this.router.navigate(['/login']);
      });
      return;
    }
    // if email address exists, just exit edit mode and clear error messages
    this.isEdit = false;
    this.clearErrorMessages();
  }

  clearErrorMessages(): void {
    this.isError = false;
    this.isFormError = false;
  }

  back(): void {
    lastValueFrom(this.authService.logout()).then(() => {
      this.router.navigate(['/login']);
    });
  }
}
